import { Grid } from "@mui/material";
import { GridColDef, GridPaginationModel } from "@mui/x-data-grid";
import { FC, FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import { ArrowRightIconButton } from "../../../components/Primitives";
import SearchField from "../../../components/SearchField";
import { CustomTable } from "../../../components/Tables/custom-table";
import { IGroup } from "../../../domain/group/group";
import { useBaseDataGridStyles } from "../../../style/baseDataGrid.style";
import { AvailableBaseRoutes } from "../../../utils/constants";
import { usePomAgencyContext } from "../pom-agency.provider";

const PomAgencyGroupsToolbar: FC = () => {
  const { t } = useTranslation();
  const { classes } = useBaseDataGridStyles();
  const { setNewErpQuery, setNewNameQuery, curErpQuery, curNameQuery } = usePomAgencyContext();

  return (
    <Grid direction="row" container className={classes.search}>
      <Grid className={classes.searchGrid} container spacing={4}>
        <Grid className={classes.searchGrid} item>
          <SearchField
            tooltip={t("basedata.groups.table.search.erp")}
            submitSearch={true}
            inputTimeout={0}
            initialValue={curErpQuery}
            onSearchSubmit={(value: string) => {
              setNewErpQuery(value);
            }}
            placeholder={t("basedata.groups.table.search.erp")}
          />
        </Grid>
        <Grid className={classes.searchGrid} item>
          <SearchField
            tooltip={t("basedata.groups.table.search.agencyName")}
            submitSearch={true}
            inputTimeout={0}
            initialValue={curNameQuery}
            onSearchSubmit={(value: string) => {
              setNewNameQuery(value);
            }}
            placeholder={t("basedata.groups.table.search.agencyName")}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export const PomAgencyGroupsTable: FunctionComponent = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { agencyGroups, isLoading, page, setNewPage, pageSize, setNewPageSize, itemCount } = usePomAgencyContext();

  const columns: GridColDef[] = [
    {
      field: "erpNumber",
      headerName: t("basedata.groups.table.erpNr"),
      flex: 1,
    },
    {
      field: "name",
      headerName: t("basedata.groups.table.name"),
      flex: 1,
    },
    {
      field: "__actions",
      headerName: "",
      width: 60,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <ArrowRightIconButton
          onClick={() => {
            const group = params.row as IGroup;
            if (!group.erpNumber) {
              return;
            }
            history.push(AvailableBaseRoutes.GroupDetail.replace(":erpNumber", group.erpNumber));
          }}
        />
      ),
    },
  ];

  return (
    <CustomTable
      columns={columns}
      rows={agencyGroups}
      loading={isLoading}
      getRowId={(row) => row.erpNumber}
      paginationModel={{ page, pageSize }}
      onPaginationModelChange={(model: GridPaginationModel) => {
        setNewPage(model.page);
        setNewPageSize(model.pageSize);
      }}
      rowCount={itemCount}
      pageSizeOptions={[10, 20, 50, 100]}
      paginationMode="server"
      slots={{ toolbar: PomAgencyGroupsToolbar }}
    />
  );
};
